import { UploadImageAsFormData } from "../components/operational/UploadImageAsFormData";
import store from "../redux/store";
import { blobUrlToBlobConverter } from "./Converters";
import { JSONValidator, validateHttps } from "./Validators";
import { v4 as uuid } from "uuid";
const debounce = (func: Function, wait: number) => {
    let timeout: any;
    return (...args: any) => {
        clearTimeout(timeout);
        return new Promise((resolve, reject) => {
            timeout = setTimeout(async () => {
                try {
                    const result = await func(...args);
                    resolve(result);
                } catch (error) {
                    reject(error);
                }
            }, wait);
        });
    };
}
const changeIframeOnClick = (pointTo: string) => {
    const state = store.getState()
    const isWebview = state.themeSlice?.settings?.isWebView
    if (isWebview) {
        const webview = document.querySelector("#mobligo-webview")
        if (webview) {
            webview.setAttribute("isLoading", "true")
            webview.setAttribute("src", validateHttps(pointTo))
        }
    }
}

function copyText(copyText: string) {

    navigator.clipboard.writeText(copyText);


}

const uploadBlobImage = async (blobUrl: string) => {

    const file = await blobUrlToBlobConverter(blobUrl)
    const fileData = new File([file], uuid() + ".png", {
        type: "image/png"
    })
    const response = await UploadImageAsFormData(fileData, true)
    return response?.result?.resultData?.url
}

const getLocalPublishData = () => {
    const localPublishData = localStorage.getItem("localPublishData")
    const jsonLocalPublishData = JSONValidator(localPublishData)
    const storeId = localStorage.getItem("activeStoreId")
    const storeJsonData = jsonLocalPublishData?.[storeId as keyof typeof jsonLocalPublishData]
    return storeJsonData
}

export { debounce, changeIframeOnClick, copyText, uploadBlobImage, getLocalPublishData }